import React from 'react'
import '../App.css'
import Bodyticketreport from './bodyticketreport'
export class Bodyappticketreportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodyticketreport/>
            </div>
        );
    }
}